import { useCurrentUserQuery } from '@data/currentUser/currentUser'
import { useAuthStore } from '@store/auth.store'
import {
  resolveValveEditPermissions,
  ValveEditDevice,
  ValveEditPermissions,
} from './valveEditPermissions'

export const useValveEditPermissions = (device: ValveEditDevice): ValveEditPermissions => {
  const permissions = useAuthStore((state) => state.permissions)
  const { data: user } = useCurrentUserQuery()

  return resolveValveEditPermissions(permissions, user, device)
}
